import ParameterValidator from '@mvps-genesis/parameter-validator';
import decodeEntities from '@mvps-genesis/decode-entities';

export default class ConfirmAction {

	// Define "public" properties
	elements;

	dialog;

	redirectUrl;

	constructor (
		elements = '.js-confirm-action',
		{
			message = 'Are you sure you want to continue?',
			triggerEvent = 'click'
		} = {}
	) {

		// Create validator instance
		const validator = new ParameterValidator(this);

		// Validate and set properties
		this.elements = validator.isElementList('elements', elements);
		this.message = validator.isString('options.message', message);
		this.triggerEvent = validator.isString('options.triggerEvent', triggerEvent);

		// Bind any events
		this.bindEvents();

	}

	bindEvents () {
		for (const element of this.elements) {
			element.addEventListener(this.triggerEvent, this.onEvent.bind(this), false);
		}
	}

	determineMessage (element) {
		let message = typeof element === 'object' && element instanceof HTMLElement && 'message' in element.dataset && element.dataset.message.length ? String(element.dataset.message) : this.message;

		return decodeEntities(message);
	}

	onConfirm () {

		return true;

	}

	onCancel (e) {

		e.preventDefault();
		e.stopPropagation();

		return false;

	}

	openDialog (e) {

		let message = this.determineMessage(e.currentTarget);

		// eslint-disable-next-line no-alert
		this.dialog = window.confirm(message);

	}

	onEvent (e) {

		this.openDialog(e);

		if (this.dialog) {

			return this.onConfirm();

		}

		return this.onCancel(e);

	}

}
